import { NgModule, Optional, SkipSelf } from '@angular/core';

import { SettingsService } from './settings/settings.service';
import { ThemesService } from './themes/themes.service';
import { MenuService } from './menu/menu.service';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { AuthenticationService } from './services/authentication.service';
import { NotificationsService } from './notifications/notifications.service';

@NgModule({
    imports: [
    ],
    providers: [
        SettingsService,
        ThemesService,
        MenuService,
        AuthenticationService,
        NotificationsService
    ],
    declarations: [
        
    ],
    exports: [
        
    ]
})
export class CoreModule {
    constructor( @Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
